import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NgbModal, NgbModalConfig, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgxPaginationModule } from 'ngx-pagination';
import { ToastrService } from 'ngx-toastr';
import { PressingCategoryService } from '../../../../core/services/pressing-category.service';
import { MobilePressingService } from '../../../../core/services/mobile-pressing.service';
import { PressingAppointmentService } from '../../../../core/services/pressing-appointment.service';
import { SampleSearchPipe } from '../../../../core/pipes/sample-search.pipe';
import { AppActionCheck } from '../../../../core/utils/app-action-check';
import { AppErrorShow } from '../../../../core/utils/app-error-show';
import { AppSweetAlert } from '../../../../core/utils/app-sweet-alert';
import { LocalStorageService } from '../../../../core/utils/local-stoarge-service';
import { LoadingComponent } from '../../../shared/loading/loading.component';
import { StatusComponent } from '../../component/status/status.component';

@Component({
  selector: 'app-pressing',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    NgbModule,
    NgxPaginationModule,
    LoadingComponent,
    SampleSearchPipe,
    StatusComponent
  ],
  templateUrl: './pressing.component.html',
  styleUrl: './pressing.component.css'
})
export class PressingComponent {
  buttonsPermission: any | undefined;
  buttonsPermission2: any | undefined;
  buttonsPermission3: any | undefined;

  // Tab 1: Catégories
  data: any[] = [];
  selected_data: any;
  search_text = "";
  pg = { pageSize: 10, p: 0, total: 0 }

  // Tab 2: Pressings mobiles
  dataPressings: any[] = [];
  selected_pressing: any;
  search_text2 = "";
  pg2 = { pageSize: 10, p: 0, total: 0 }

  // Tab 3: Demandes
  dataAppointments: any[] = [];
  selected_appointment: any;
  search_text3 = "";
  pg3 = { pageSize: 10, p: 0, total: 0 }

  loading = false;
  loading2 = false;
  tag = "Pressing";

  constructor(
    private categoryService: PressingCategoryService,
    private pressingService: MobilePressingService,
    private appointmentService: PressingAppointmentService,
    private toastrService: ToastrService,
    config: NgbModalConfig,
    private lsService: LocalStorageService,
    private modalService: NgbModal) {
    config.backdrop = 'static';
    config.keyboard = false;
  }

  ngOnInit(): void {
    this.init()
    this.getActions()
    this.getActions2()
    this.getActions3()
  }

  init() {
    this.getAllCategories()
    this.getAllPressings()
    this.getAllAppointments()
  }

  //#region Catégories

  getAllCategories() {
    this.loading2 = true
    this.categoryService.getAll().subscribe((res: any) => {
      this.data = res.data
      this.pg.pageSize = 10
      this.pg.p = 0
      this.pg.total = res.data.length
      this.modalService.dismissAll()
      this.loading2 = false
    },
      (err: any) => {
        this.loading2 = false
        AppErrorShow.showError("Gestion du pressing", err)
      })
  }

  storeCategory(value: any) {
    this.loading = true
    this.categoryService.store(value).subscribe((res: any) => {
      this.loading = false
      this.toastrService.success(res.message)
      this.getAllCategories()
    },
      (err: any) => {
        this.loading = false
        AppErrorShow.showError("Gestion du pressing", err)
      })
  }

  updateCategory(value: any) {
    this.loading = true
    this.categoryService.update(this.selected_data.id, value).subscribe((res: any) => {
      this.loading = false
      this.toastrService.success(res.message)
      this.getAllCategories()
    },
      (err: any) => {
        this.loading = false
        AppErrorShow.showError("Gestion du pressing", err)
      })
  }

  deleteCategory() {
    if (!this.verifyIfChecked(this.selected_data)) return;
    let confirmed = AppSweetAlert.confirmBox('info', 'Suppression', 'Voulez vous vraiment retirer cet élément?',);
    confirmed.then((result: any) => {
      if (result.isConfirmed) {
        this.categoryService.delete(this.selected_data.id).subscribe((res: any) => {
          this.toastrService.success(res.message)
          this.getAllCategories()
        },
          (err: any) => {
            AppErrorShow.showError("Gestion du pressing", err)
          })
      }
    })
  }

  checked(el?: any) {
    this.selected_data = el;
  }

  getActions() {
    this.buttonsPermission = {
      add: AppActionCheck.check(this.tag, 'Ajouter'),
      edit: AppActionCheck.check(this.tag, 'Editer'),
      delete: AppActionCheck.check(this.tag, 'Supprimer')
    };
  }

  getPage1(event: any) {
    this.pg.p = event
  }

  //#endregion

  //#region Pressings mobiles

  getAllPressings() {
    this.loading2 = true
    this.pressingService.getAllAdmin().subscribe((res: any) => {
      this.dataPressings = res.data
      this.pg2.pageSize = 10
      this.pg2.p = 0
      this.pg2.total = res.data.length
      this.modalService.dismissAll()
      this.loading2 = false
    },
      (err: any) => {
        this.loading2 = false
        AppErrorShow.showError("Gestion du pressing", err)
      })
  }

  storePressing(value: any) {
    this.loading = true
    value['available'] = true
    this.pressingService.store(value).subscribe((res: any) => {
      this.loading = false
      this.toastrService.success(res.message)
      this.getAllPressings()
    },
      (err: any) => {
        this.loading = false
        AppErrorShow.showError("Gestion du pressing", err)
      })
  }

  updatePressing(value: any) {
    this.loading = true
    this.pressingService.update(this.selected_pressing.id, value).subscribe((res: any) => {
      this.loading = false
      this.toastrService.success(res.message)
      this.getAllPressings()
    },
      (err: any) => {
        this.loading = false
        AppErrorShow.showError("Gestion du pressing", err)
      })
  }

  deletePressing() {
    if (!this.verifyIfChecked(this.selected_pressing)) return;
    let confirmed = AppSweetAlert.confirmBox('info', 'Suppression', 'Voulez vous vraiment retirer cet élément?',);
    confirmed.then((result: any) => {
      if (result.isConfirmed) {
        this.pressingService.delete(this.selected_pressing.id).subscribe((res: any) => {
          this.toastrService.success(res.message)
          this.getAllPressings()
        },
          (err: any) => {
            AppErrorShow.showError("Gestion du pressing", err)
          })
      }
    })
  }

  togglePressingState(state: any) {
    if (!this.verifyIfChecked(this.selected_pressing)) return;
    this.loading = true
    this.pressingService.setState(this.selected_pressing.id, state).subscribe((res: any) => {
      this.loading = false
      this.toastrService.success(res.message)
      this.getAllPressings()
    },
      (err: any) => {
        this.loading = false
        AppErrorShow.showError("Gestion du pressing", err)
      })
  }

  checkedPressing(el?: any) {
    this.selected_pressing = el;
  }

  getActions2() {
    this.buttonsPermission2 = {
      add: AppActionCheck.check(this.tag, 'Ajouter'),
      edit: AppActionCheck.check(this.tag, 'Editer'),
      delete: AppActionCheck.check(this.tag, 'Supprimer'),
      status: true
    };
  }

  getPage2(event: any) {
    this.pg2.p = event
  }

  //#endregion

  //#region Demandes (rendez-vous)

  getAllAppointments() {
    this.loading2 = true
    this.appointmentService.getAll().subscribe((res: any) => {
      this.dataAppointments = res.data
      this.pg3.pageSize = 10
      this.pg3.p = 0
      this.pg3.total = res.data.length
      this.modalService.dismissAll()
      this.loading2 = false
    },
      (err: any) => {
        this.loading2 = false
        AppErrorShow.showError("Gestion du pressing", err)
      })
  }

  changeAppointmentStatus(status: any) {
    if (!this.verifyIfChecked(this.selected_appointment)) return;
    this.loading = true
    this.appointmentService.changeStatus(this.selected_appointment.id, status).subscribe((res: any) => {
      this.loading = false
      this.toastrService.success(res.message)
      this.getAllAppointments()
    },
      (err: any) => {
        this.loading = false
        AppErrorShow.showError("Gestion du pressing", err)
      })
  }

  deleteAppointment() {
    if (!this.verifyIfChecked(this.selected_appointment)) return;
    let confirmed = AppSweetAlert.confirmBox('info', 'Suppression', 'Voulez vous vraiment retirer cet élément?',);
    confirmed.then((result: any) => {
      if (result.isConfirmed) {
        this.appointmentService.delete(this.selected_appointment.id).subscribe((res: any) => {
          this.toastrService.success(res.message)
          this.getAllAppointments()
        },
          (err: any) => {
            AppErrorShow.showError("Gestion du pressing", err)
          })
      }
    })
  }

  checkedAppointment(el?: any) {
    this.selected_appointment = el;
  }

  getActions3() {
    this.buttonsPermission3 = {
      delete: AppActionCheck.check(this.tag, 'Supprimer'),
      status: true
    };
  }

  getPage3(event: any) {
    this.pg3.p = event
  }

  //#endregion

  verifyIfChecked(el: any) {
    if (el == null) {
      this.toastrService.warning("Aucun élément selectionné");
      return false;
    }
    return true;
  }

  add(content: any) {
    this.modalService.open(content, { size: 'lg' });
  }

  edit(content: any) {
    if (!this.verifyIfChecked(this.selected_data)) return;
    this.modalService.open(content, { size: 'lg' });
  }

  addPressingModal(content: any) {
    this.modalService.open(content, { size: 'lg' });
  }

  editPressingModal(content: any) {
    if (!this.verifyIfChecked(this.selected_pressing)) return;
    this.modalService.open(content, { size: 'lg' });
  }

  dismiss() {
    this.modalService.dismissAll()
  }
}
